<template>
  <div class="com" @click="closeModal($event)">
    <div class="txt">All fields are required</div>
    <div class="wrapper">
      <div class="form-wrap">
        <div class="input-wrap">
          <input
            type="text"
            @change="camelCaseVal('title', $event ,title_count)"
            @focus="removeCaps('title', $event, 'focus')"
            v-on:keyup.delete="removeCaps('title', $event, 'delete')"
            v-model="title"
            v-validate="'required|max:100'"
            class="input"
            name="title"
            placeholder="Project Name"
            @input="onFocusOut"
          />
          <span class="validate-error zip" v-if="errors.has('title')">
            {{ errors.first("title") }}
          </span>
        </div>
        <div class="input-wrap small">
          <div class="input-title">Sampling Date</div>
          <div @click="showError" class="datepickerWrapDiv">
            <Datepicker
              :disabledDates="{ from: serverTime }"
              placeholder="Select Date"
              v-model="sampling_date"
              name="sampling_date"
              v-validate="'required'"
              :format="formatDate"
              :calendar-class="{ calendarWrap: true }"
              :class="{ datepickerWrap: true }"
              :input-class="{ datepickerInput: true, error: dateError }"
              @input="onFocusOut"
            ></Datepicker>
          </div>
        </div>
        <div class="inputs-wrap small">
          <div class="input-title">Who Collected the Samples?</div>
          <div class="input-wrap small">
            <input
              id="collected-first-name-reg-input"
              type="text"
              @change="changeVal('collected_first_name', $event, collected_first_name_count)"
              @focus="removeCaps('collected_first_name', $event, 'focus')"
              v-on:keyup.delete="removeCaps('collected_first_name', $event, 'delete')"
              v-model="collected_first_name"
              v-validate="'required|max:50'"
              class="input"
              name="collected_first_name"
              placeholder="First Name"
              @input="onFocusOut"
            />
            <span
              class="validate-error zip"
              v-if="errors.has('collected_first_name')"
              >{{ errors.first("collected_first_name") }}</span
            >
          </div>
          <div class="input-wrap small">
            <input
              id="collected-last-name-reg-input"
              type="text"
              @change="changeVal('collected_last_name', $event, collected_last_name_count)"
              @focus="removeCaps('collected_last_name', $event, 'focus')"
              v-on:keyup.delete="removeCaps('collected_last_name', $event, 'delete')"
              v-model="collected_last_name"
              v-validate="'required|max:50'"
              class="input"
              name="collected_last_name"
              placeholder="Last Name"
              @input="onFocusOut"
            />
            <span
              class="validate-error zip"
              v-if="errors.has('collected_last_name')"
              >{{ errors.first("collected_last_name") }}</span
            >
          </div>
        </div>
        <div class="inputs-wrap small">
          <div class="input-title">Where Were Samples Collected?</div>
          <div class="input-wrap small">
            <input
              type="text"
              class="input"
              v-validate="'regex:[0-9]|required|numeric|length:5'"
              placeholder="Zip Code"
              name="zip"
              maxlength="5"
              @input="getZip"
              v-model="zip"
            />
          </div>
          <div class="input-wrap small">
            <input
              type="text"
              class="input"
              placeholder="Address"
              v-validate="'required'"
              name="address"
              maxlength="50"
              @change="camelCaseVal('address', $event, address_count)"
              @focus="removeCaps('address', $event, 'focus')"
              v-on:keyup.delete="removeCaps('address', $event, 'delete')"
              v-model="address"
              @input="onFocusOut"
            />
            <!--<span class="validate-error zip" v-if="errors.has('address')">This field is required.</span>-->
          </div>
          <div class="input-wrap small">
            <input
              type="text"
              class="input"
              name="city"
              placeholder="City"
              maxlength="25"
              v-validate="'required'"
              @change="changeVal('city', $event, city_count)"
              @focus="removeCaps('city', $event, 'focus')"
              v-on:keyup.delete="removeCaps('city', $event, 'delete')"
              v-model="city"
              @input="onFocusOut"
            />
            <!--<span class="validate-error zip" v-if="errors.has('city')">This field is required.</span>-->
          </div>
          <div class="input-wrap small">
            <input
              type="text"
              class="input"
              name="state"
              v-validate="'required'"
              placeholder="State"
              maxlength="25"
              @change="changeVal('state', $event, state_count)"
              @focus="removeCaps('state', $event, 'focus')"
              v-on:keyup.delete="removeCaps('state', $event, 'delete')"
              v-model="state"
              @input="onFocusOut"
            />
          </div>
        </div>
        <div class="inputs-wrap small">
          <div class="inputs-wrap">
            <div class="input-title">Outdoor Samples</div>
            <div v-on:mouseleave="closeOutdoorSampleSelect()">
              <input
                @input="selectedOutdoorModelErrors()"
                name="Outdoor Sample"
                @keyup.enter="onOutdoorEnter()"
                v-model="outdoorSample"
                @click="showOutdoorSampleSelect = true"
                placeholder="Select"
                readonly
                class="input"
                v-validate="'max:35'"
              />
              <img
                src="../../../images/shared/drop.png"
                alt="#"
                class="drop-down-icone"
              />
              <ul
                class="dropDown"
                v-show="showOutdoorSampleSelect === true"
                v-on:focusout="closeOutdoorSampleSelect()"
              >
                <li
                  id="outdoor-dropDown-item_1"
                  class="dropDown-item"
                  @click="setOutdoorItem('Front Entrance', 'outdoorSample')"
                >
                  <span>Front Entrance</span>
                </li>
                <li
                  id="outdoor-dropDown-item_2"
                  class="dropDown-item"
                  @click="setOutdoorItem('Back Entrance', 'outdoorSample')"
                >
                  <span>Back Entrance</span>
                </li>
                <li
                  id="outdoor-dropDown-item_3"
                  class="dropDown-item"
                  @click="setOutdoorItem('Side Entrance', 'outdoorSample')"
                >
                  <span>Side Entrance</span>
                </li>
                <li
                  id="outdoor-dropDown-item_4"
                  class="dropDown-item"
                  @click="setOutdoorItem('Balcony', 'outdoorSample')"
                >
                  <span>Balcony</span>
                </li>
                <li class="dropDown-item">
                  <input
                    type="text"
                    v-model="outdoorSample"
                    @change="changeVal('outdoorSample', $event, 0)"
                    class="dropDownInput"
                    @keyup.enter="closeOutdoorSampleSelect()"
                    placeholder="Enter Other Description"
                    v-validate="'max:35'"
                  />
                </li>
              </ul>
            </div>
            <span class="validate-error zip" v-if="outdoorSample && outdoorSample.length > 35" >
                    Outdoor Sample may not exceed 35 characters.
            </span>
            <span class="validate-error zip" v-else >{{
              errors.first('outdoorSample')
            }}</span>
          </div>
          <div class="descriptionInput"><span class="first-sent">The outdoor sample is required to produce a report.</span> The formula for calculating results depends largely upon a comparison between the indoor samples and the outdoor sample.</div>
        </div>
        <div class="inputs-wrap small">
          <div class="inputs-wrap small" v-for="(item, index) in indoorSamples">
            <div class="input-title">Indoor Sample #{{ index + 1 }}</div>
            <div v-on:mouseleave="closeSelect()">
            <input
              @input="selectedModelErrors()"
              :name="'Indoor Sample #' + (index + 1)"
              @keyup.enter="onEnter()"
              v-model="$data[`selectedSample${index + 1}`]"
              @click="openDropdown(`show${item.id}`)"
              placeholder="Select"
              readonly
              class="input"
              v-validate="'max:35'"
            />
            <img
              src="../../../images/shared/drop.png"
              alt="#"
              class="drop-down-icone"
            />
            <ul
              class="dropDown"
              v-show="show1 === `show${item.id}`"
              v-on:focusout="closeSelect()"
            >
              <li
                :id="`dropDown-item1_${index + 1}`"
                class="dropDown-item"
                @click="setItem('Attic', `selectedSample${index + 1}`, 1, index+1)"
              >
                <span>Attic</span>
              </li>
              <li
                :id="`dropDown-item2_${index + 1}`"
                class="dropDown-item"
                @click="setItem('Basement', `selectedSample${index + 1}`, 2, index+1)"
              >
                <span>Basement</span>
              </li>
              <li
                :id="`dropDown-item3_${index + 1}`"
                class="dropDown-item"
                @click="setItem('Bathroom', `selectedSample${index + 1}`, 3, index+1)"
              >
                <span>Bathroom</span>
              </li>
              <li
                :id="`dropDown-item4_${index + 1}`"
                class="dropDown-item"
                @click="setItem('Crawlspace', `selectedSample${index + 1}`, 4, index+1)"
              >
                <span>Crawlspace</span>
              </li>
              <li
                :id="`dropDown-item5_${index + 1}`"
                class="dropDown-item"
                @click="setItem('Dining Room', `selectedSample${index + 1}`, 5, index+1)"
              >
                <span>Dining Room</span>
              </li>
              <li
                :id="`dropDown-item6_${index + 1}`"
                class="dropDown-item"
                @click="setItem('Garage', `selectedSample${index + 1}`, 6, index+1)"
              >
                <span>Garage</span>
              </li>
              <li
                :id="`dropDown-item7_${index + 1}`"
                class="dropDown-item"
                @click="setItem('Living Room', `selectedSample${index + 1}`, 7, index+1)"
              >
                <span>Living Room</span>
              </li>
              <li
                :id="`dropDown-item8_${index + 1}`"
                class="dropDown-item"
                @click="setItem('Master Bedroom', `selectedSample${index + 1}`, 8, index+1)"
              >
                <span>Master Bedroom</span>
              </li>
              <li
                :id="`dropDown-item9_${index + 1}`" 
                class="dropDown-item"
                @click="setItem('Utility Room', `selectedSample${index + 1}`, 9, index+1)"
              >
                <span>Utility Room</span>
              </li>
              <li
                :id="`dropDown-item10_${index + 1}`"
                class="dropDown-item"
                @click="
                  setItem('Water Heater Closet', `selectedSample${index + 1}`, 10, index+1)
                "
              >
                <span>Water Heater Closet</span>
              </li>
              <li
                :id="`dropDown-item11_${index + 1}`"
                class="dropDown-item"
                @click="
                  setItem('Family Room', `selectedSample${index + 1}`, 11, index+1)
                "
              >
                <span>Family Room</span>
              </li>
              <li class="dropDown-item">
                <input
                  type="text"
                  v-model="$data[`selectedSample${index + 1}`]"
                    @change="changeVal(`selectedSample${index + 1}`, $event, 0)"
                  class="dropDownInput"
                  @keyup.enter="closeSelect()"
                  placeholder="Enter Other Description"
                  v-validate="'max:35'"
                />
              </li>
            </ul>
            </div>
            <span class="validate-error zip" v-if="$data[`selectedSample${index + 1}`] && $data[`selectedSample${index + 1}`].length > 35" >
              Indoor Sample {{index + 1}} may not exceed 35 characters. 
            </span>
            <span class="validate-error zip" v-else>{{
              errors.first(`Indoor Sample #${index + 1}`)
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="inputs-wrap small">
        <div class="validate-errors" v-if="errorMessage !== ''">
              <span v-html="$sanitizeBr(errorMessage)"></span>
        </div>
    </div>
    <div class="btn-wrap">
      <button
        class="btn"
        @click.prevent="$validator.validateAll()"
        @click="switchStep"
        :disabled="!isComputed"
      >
        Continue
      </button>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "Step3",
  data() {
    return {
      title: "",
      sampling_date: "",
      dateError: false,
      show: false,
      showOutdoorSampleSelect: false,
      show1: "",
      custom: true,
      outdoorSample: "",
      selectedModel: "Near Front Entrance",
      selectedSample1: "",
      selectedSample2: "",
      selectedSample3: "",
      customError : {},
      collected_first_name: "",
      collected_last_name: "",
      zip: null,
      state: null,
      address: null,
      indoorSamples: [],
      city: null,
      selectedOutdoorModelError: true,
      selectedModelError: true,
      disabledIds: [],
      title_count:0,
      collected_first_name_count:0,
      address_count:0,
      city_count:0,
      state_count:0,
      collected_last_name_count:0,
      errorMessage : ''
    };
  },
  methods: {
    ...mapActions(["updateUserInfo","sendTempSub", "simplingDetails", "saveTestKitDetails","fetchServerTime"]),
    onFocusOut(){
      let title = "", sampling_date = "", collected_first_name = "", collected_last_name = "", city = "", state ="";
      let outdoorSample = "", indoorSamples1 = "", indoorSamples2 = "", indoorSamples3 = "", zip ="",address="";

      if(!this.errors.has('title')){
          title = this.title;
      }
      if(!this.errors.has('sampling_date')){
          sampling_date = this.sampling_date;
      }
      if(!this.errors.has('collected_first_name')){
          collected_first_name = this.collected_first_name;
      }
      if(!this.errors.has('collected_last_name')){
          collected_last_name = this.collected_last_name;
      }
      if(!this.errors.has('city')){
          city = this.city;
      }
      if(!this.errors.has('zip')){
        zip = this.zip;
      }
      if(!this.errors.has('address')){
        address = this.address;
      }
      if(!this.errors.has('state')){
        state = this.state;
      }
      if(!this.errors.has('outdoorSample')){
          outdoorSample = this.outdoorSample;
      }
      if(!this.errors.has('selectedSample1')){
          indoorSamples1 = this.selectedSample1;
      }
      if(!this.errors.has('selectedSample2')){
          indoorSamples2 = this.selectedSample2;
      }
      if(!this.errors.has('indoorSamples3')){
          indoorSamples3 = this.selectedSample3;
      }

      const user = {
          title,
          sampling_date,
          collected_first_name,
          collected_last_name,
          city,
          zip,
          state,
          address,
          outdoorSample,
          indoorSamples1,
          indoorSamples2,
          indoorSamples3,
          kit_id: this.$store.getters.userInfo.testkits[0].kit_id,
      };

      this.sendTempSub(user);
    },
    getZip() {
      let self = this;
      this.zip = this.zip ? this.zip.substr(0, 5).replace(/\D/g, "") : "";
      if (!self.state && !self.city && this.zip.length === 5) {
        this.onFocusOut();
        fetch(`https://ziptasticapi.com/${this.zip}`)
          .then(res => {
            return res.json();
          })
          .then(res => {
            self.state = res.state;
            self.city = this.capitalizeVal(res.city);
          });
      }
    },
    number(num) {
      return num;
    },
    formatDate(date) {
      return moment(date).format("MMMM D, YYYY");
    },
    showError(e) {
      this.sampling_date === ""
        ? (this.dateError = true)
        : (this.dateError = false);
    },
    removeCaps(model, e, type){
        if(type == 'focus'){
          let val = 0;
          if(e.target.value.length > 0) {
            val = 1;
          }
          if(model == "collected_first_name"){
            this.collected_first_name_count = val;
          } else if(model == "city"){
            this.city_count = val;
          } else if(model == "state"){
            this.state_count = val;
          } else if(model == "collected_last_name"){
            this.collected_last_name_count = val;
          } else  if(model == "title"){
            this.title_count = val;
          } else if(model == "address"){
            this.address_count  = val;
          }
        } else if(e.target.value.length == 0)  {
          if(model == "collected_first_name" && this.collected_first_name_count == 0){
            this.collected_first_name_count = this.collected_first_name_count+1;
          } else if(model == "city" && this.city_count == 0){
            this.city_count = this.city_count+1;
          } else if(model == "state" && this.state_count == 0){
            this.state_count = this.state_count+1;
          } else if(model == "collected_last_name" && this.collected_last_name_count == 0){
            this.collected_last_name_count = this.collected_last_name_count+1;
          } else  if(model == "title" && this.title_count == 0){
            this.title_count = this.title_count+1;
          } else if(model == "address" && this.address_count == 0){
            this.address_count  = this.address_count+1;
          }
        }
    },
    changeVal(model, e, count) {
      if (count == 0 && e.target.value.length > 0){
        e.target.value = this.capitalizeVal(e.target.value);
        e.target.style.textTransform = 'none';
      }
      if (model.startsWith("selectedSample")) {
        this.$validator.validate(`Indoor Sample #${model.substr(14)}`);
        if(e.target.value.length > 0 && e.target.value.trim() != '') {
          this[model] = e.target.value;
        } else {
          this[model] = null;
        }
      } else if (model === "outdoorSample") {
        if(e.target.value.length > 0 && e.target.value.trim() != '') {
          this[model] = e.target.value.trim();
        } else {
          this[model] = null;
        }
      } else if (model === "state") {
        this[model] =
          e.target.value.length <= 2
            ? e.target.value.toUpperCase()
            : e.target.value;
      } else {
        this[model] = e.target.value;
      }
      if (model.startsWith("selectedSample") || model === "outdoorSample") {
        this.customError = {};
        if (e.target.value != null && e.target.value.trim() != '') {
          this[model] = e.target.value;
          this.errorMessage = '';
          this.isSameCheck();
        }
      }
    },
    isSameCheck(){
      let samples = ['selectedSample1','selectedSample2','selectedSample3','outdoorSample'];
      samples.forEach((sample) => {
        let currentValue = this[sample];
        if (currentValue !== null) {
          for (let i = 1; i <= 3; i++) {
            let indoorSample = this['selectedSample' + i];
            if (indoorSample !== null && indoorSample !== "" && sample !== 'selectedSample' + i && currentValue.toUpperCase() === indoorSample.toUpperCase()) {
              let key = indoorSample.toUpperCase();
              if (!this.customError[key]) {
                this.customError[key] = [];
              }
              if (!this.customError[key].includes(`Sample ${i}`)) {
                this.customError[key].push(`Sample ${i}`);
              }
            }
          }
          if (this.outdoorSample !== null && this.outdoorSample !== "" &&  sample != 'outdoorSample' && currentValue.toUpperCase() === this.outdoorSample.toUpperCase()) {
            let key = this.outdoorSample.toUpperCase();
            // Check if key already exists in customError and if not, create a new array for that key
            if (!this.customError[key]) {
              this.customError[key] = [];
            }

            if (!this.customError[key].includes(`Outdoor Sample`)) {
              this.customError[key].push(`Outdoor Sample`);
            }
          }
        }
      });
    },
    camelCaseVal(model, e, count) {
      if(count == 0 && e.target.value.length > 0){
        e.target.value = this.camelCapitalizeVal(e.target.value);
        e.target.style.textTransform = 'none';
      }
      if (model === "state") {
        this[model] =
          e.target.value.length <= 2
            ? e.target.value.toUpperCase()
            : e.target.value;
      } else {
        this[model] = e.target.value;
      }
    },
    switchStep() {
      if (
        !this.isComputed ||
        this.errors.any() ||
        this.dateError ||
        this.selectedModelError
      ) {
        return;
      }
      const indoorSamples = [];
      this.indoorSamples.forEach((item, index) => {
        const selected = `selectedSample${index + 1}`;
        indoorSamples.push({
          type: this[selected],
          id: item.id,
          testkit_id: item.testkit_id
        });
      });
      const user = {
        kit_id: this.userInfo.kit_id,
        kit_id_confirmation: this.userInfo.kit_id,
        sampling_date: this.sampling_date,
        collected_first_name: this.collected_first_name,
        title: this.title,
        collected_last_name: this.collected_last_name,
        address: this.address,
        zip: this.zip,
        city: this.city,
        state: this.state,
        indoor_samples: indoorSamples,
        outdoor_sample: this.outdoorSample,
        send_notification: false
      };
      this.saveTestKitDetails(user).then(res => {
        this.$emit("nextStep", 1);
      });
    },
    prev() {
      this.$emit("prevStep", {
        step: 1,
        notificationData: {
          emailInput: false,
          phoneInput: false,
          errorCode: true,
          emailInputVer: false,
          phoneInputVer: false
        }
      });
    },
    openDropdown(el) {
      this.show1 === "" ? (this.show1 = el) : (this.show1 = "");
    },
    // checkInput(e) {
    //   e.target.value === '' ? this.selectedModelError = true : this.selectedModelError = false;
    // },
    setOutdoorItem(txt, model) {
      this[model] = txt || "";
      this.showOutdoorSampleSelect = false;
      this.customError = {};
      this.errorMessage = '';
      this.isSameCheck();
      this.$validator.reset();
      this.selectedOutdoorModelErrors();
    },
    setItem(txt, model, id, index) {
      this[model] = txt;
      this.show1 = "";
      this.customError = {};
      this.errorMessage = '';
      this.isSameCheck();
      var element1 = document.getElementById('dropDown-item'+id+'_1');
      var element2 = document.getElementById('dropDown-item'+id+'_2');
      var element3 = document.getElementById('dropDown-item'+id+'_3');

      if(this.disabledIds[index]) {
        var existingElement1 = document.getElementById('dropDown-item'+this.disabledIds[index]+'_1');
        var existingElement2 = document.getElementById('dropDown-item'+this.disabledIds[index]+'_2');
        var existingElement3 = document.getElementById('dropDown-item'+this.disabledIds[index]+'_3');

        if(existingElement1) {
          existingElement1.classList.remove("disabled");
        }
        if(existingElement2) {
          existingElement2.classList.remove("disabled");
        }
        if(existingElement3) {
          existingElement3.classList.remove("disabled");
        }
      }

      if(element1) {
        element1.classList.add("disabled");
      }
      if(element2) {
        element2.classList.add("disabled");
      }
      if(element3) {
        element3.classList.add("disabled");
      }
      this.disabledIds[index] = id;

      this.$validator.reset();
      // this.selectedModelError = false;
      this.selectedModelErrors();
    },
    onOutdoorEnter() {
      this.showOutdoorSampleSelect = false;
      this.$validator.reset();
      this.selectedOutdoorModelErrors();
    },
    onEnter() {
      this.show1 = "";
      this.$validator.reset();
      this.selectedModelErrors();
    },
    closeOutdoorSampleSelect() {
      this.showOutdoorSampleSelect = false;
      this.selectedOutdoorModelErrors();
    },
    closeSelect() {
      this.show1 = "";
      this.selectedModelErrors();
    },
    closeModal(e) {
      if (
        e.target.offsetParent &&
        e.target.offsetParent.className === "form large"
      ) {
        this.closeSelect();
      }
    },
    selectedOutdoorModelErrors() {
      if(this.outdoorSample == "") {
        this.onFocusOut();
        this.selectedOutdoorModelError = false;
      }
    },
    selectedModelErrors() {
      if (typeof this.indoorSamples !== 'undefined' && this.checkSelectedData(this.indoorSamples)) {
        this.onFocusOut();
        this.selectedModelError = false;
      }
    },
    capitalizeVal(input) {
      return input
        ? input.replace(/^\w{1,}|\w{4,}/g, function(word) {
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
          })
        : input;
    },
    camelCapitalizeVal(input) {
      return input
        ? input
            .toLowerCase()
            .split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.substring(1))
            .join(" ")
        : input;
    },
    checkSelectedData(num) {
      for (let i = 1; i <= num; i++) {
        const sample = this[`selectedSample${i}`];
        if (!sample || sample.length > 35) {
          return false;
        }
      }

      return true;
    }
  },
  computed: {
    isComputed() {
      return (
        this.sampling_date &&
        this.collected_first_name &&
        this.title &&
        this.collected_last_name &&
        this.zip &&
        this.city &&
        this.state &&
        this.address &&
        this.outdoorSample &&
        Object.keys(this.customError).length == 0 &&
        typeof this.indoorSamples !== 'undefined' &&
        this.checkSelectedData(this.indoorSamples.length)
      );
    },
    serverTime() {
       const time = this.$store.getters.getServerTime;
       return time ? new Date(time) : new Date();
    },
    ...mapGetters(["userInfo"])
  },
  watch: {
    customError(obj){
      if (Object.keys(obj).length == 0) {
        return ''; // No error message if customError is empty
      } else {
        this.errorMessage = "";
        Object.entries(obj).forEach(([key, item]) => {
          item.sort((a, b) => {
            // Handle 'Outdoor Sample' specially to ensure it comes last
            if (a === 'Outdoor Sample') return 1;
            if (b === 'Outdoor Sample') return -1;
            
            // Extract the number from the string (assuming the number is always at the end)
            const aNumber = parseInt(a.split(' ').pop());
            const bNumber = parseInt(b.split(' ').pop());

            // Compare the extracted numbers
            return aNumber - bNumber;
          });

          // Multiple items error message
          let  itemsExceptLast = '';
          if (item.length > 2) {
            itemsExceptLast = item.slice(0, -1).join(', ') + ', and ' + item[item.length - 1];
          } else if (item.length > 0) {
            itemsExceptLast = item.join(' and ');
          } 

          // Format the error message (F-14: escape user-entered names; keep <br>)
          const safeItems = String(itemsExceptLast)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
          this.errorMessage = this.errorMessage + `${safeItems} may not be the same name. <br>`;
          //  console.log(errorMessage);
          //  return errorMessage; // Output or store the error message as needed
        });
      }
    },
    userInfo(state) {
      if(this.$store.getters.userInfo.cron_status == 1) {
          if(this.$store.getters.userInfo.collected_first_name) {
            this.collected_first_name = this.$store.getters.userInfo.collected_first_name;
            var collected_first_name_field = document.getElementById('collected-first-name-reg-input');
            collected_first_name_field.classList.add("disabled");
          }
          if(this.$store.getters.userInfo.collected_last_name) {
            this.collected_last_name = this.$store.getters.userInfo.collected_last_name;
            var collected_last_name_field = document.getElementById('collected-last-name-reg-input');
            collected_last_name_field.classList.add("disabled");
          }
        }
      this.indoorSamples = state.indoorSamples;
    }
  },
  mounted() {
   
    if (this.$route.query.step) {
      for (let key in this) {
        Object.keys(this.$store.getters.userInfo.testkits[0]).forEach(item => {
          if (key === item) {
            this[key] = this.$store.getters.userInfo.testkits[0][item];
          }
        });
      }
      this.indoorSamples = this.$store.getters.userInfo.testkits[0].indoorSamples;
      this.indoorSamples.forEach((item, key) => {
        let selected = "selectedSample" + (key + 1);
        this[selected] = item.type;
      });
      //this.kit_id = this.$store.getters.userInfo.testkits[0].kit_id;
      this.$store.dispatch("userInfo", {
        kit_id: this.$store.getters.userInfo.testkits[0].kit_id
      });
    }
  },
  components: {
    Datepicker
  },
  created() {
    this.fetchServerTime();
  }
};
</script>

<style scoped lang="scss">
@import "../../../styles/colors";
.wrapper {
  width: 100%;
}
.btn-wrap {
  width: 100%;
}
.btn:disabled {
  cursor: default;
  opacity: 0.5;
}
.com {
  margin: 20px 0 0 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.txt {
  color: $blue;
  margin: -15px 0 20px;
  font-size: 14px;
  text-align: center;
  font-family: TTNormsLight, sans-serif;
  width: 100%;
}
.input {
  border-radius: 10px;
  padding: 15px 20px;
  color: $gray;
  width: 100%;
  font-size: 16px;
  border: 1px solid #cccccc;
  text-align: center;
  outline: none;
  margin: 0;
  font-family: TTNormsMedium, sans-serif;
}
.input::placeholder {
  color: $lightGray;
  font-size: 16px;
}
.input-wrap {
  margin: 0 0 15px;
}
.input.invalid {
  border: 1px solid $red;
}
.input-wrap.small {
  width: 100%;
}
.btn {
  background-color: $green;
  width: 50%;
  margin: 20px auto 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $white;
  cursor: pointer;
  outline: none;
  border: none;
  height: 45px;
  border-radius: 25px;
  max-width: 300px;
  transition: all 0.5s linear;
  font-size: 18px;
  font-family: TTNormsBold, sans-serif;
}

.descriptionInput  {
  padding: 10px;
  color: #4d4d4d;
  width: 100%;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
}

.back-btn {
  color: $green;
  border: none;
  cursor: pointer;
  outline: none;
  display: block;
  background-color: transparent;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
  margin: 36px auto 0 auto;
}
.input-title {
  color: $gray;
  padding: 6px 0 11px 0;
  display: block;
  text-align: center;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
  width: 100%;
  outline: none;
}
.input-container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .inputs-wrap {
    width: 100%;
  }
}
.inputs-wrap {
  margin: 0 0 5px;
  position: relative;
}

.inputs-wrap-error {
  margin: 20px 0 20px;
  width: 100%;
}

.inputs-wrap.small {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}
.drop-down-icone {
  position: absolute;
  right: 20px;
  top: 65%;
  height: auto;
  pointer-events: none;
}
.dropDown {
  display: block;
  position: absolute;
  height: 200px;
  overflow: auto;
  top: 75px;
  left: 0;
  width: 100%;
  z-index: 10;
  border-left: 1px solid #e5e5e5;
  border-right: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
  border-top: 1px solid transparent;
  height: 200px; /* Set a fixed height for the scrollable area */
  overflow-y: auto; /* Enable vertical scrollbar */
}
.dropDown-item {
  background-color: #fff;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
  cursor: pointer;
  text-align: center;
  color: #4f4e4e;
}
.dropDown-item span {
  display: block;
  width: 100%;
  padding: 10px 0px;
}
.dropDown-item span:hover {
  background-color: #eaeaea;
}
.dropDownInput {
  padding: 10px;
  color: #4d4d4d;
  width: 100%;
  font-size: 14px;
  text-align: center;
  font-family: TTNormsLight, sans-serif;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-bottom: 1px solid transparent;
  border-top: 1px solid #e5e5e5;
}
.dropDownInput::placeholder {
  color: #98a4ae;
}
.input:focus {
  border: 1px solid rgb(77, 144, 254);
}
.input.invalid:focus {
  border: 1px solid rgb(77, 144, 254);
}
@media (max-width: 568px) {
  .btn {
    height: 40px;
    font-size: 16px;
  }
  .back-btn {
    font-size: 16px;
  }
}
.disabled {
  pointer-events: none; 
  background-color: #e7e9eb; 
}
.first-sent {
  font-weight: bold;
}
.validate-errors {
  color: $red;
  font-size: 13px;
  font-family: TTNormsLight, sans-serif;
  bottom: -15px;
  display: inline-block;
  left: 0;
  width: 100%;
  text-align: center;
}
</style>
